import {Injectable, InjectionToken} from '@angular/core';

export const PERMISSION_ACTION_DELIMITER = '.';

export const ALL_PERMISSION = 'all';

export const ADD_PERMISSION_ACTION = 'add';
export const DELETE_PERMISSION_ACTION = 'delete';
export const EDIT_PERMISSION_ACTION = 'edit';
export const VIEW_PERMISSION_ACTION = 'view';
export const RESTRICTED = 'restricted';


const ALL_PERMISSION_ACTIONS = [ADD_PERMISSION_ACTION, DELETE_PERMISSION_ACTION, EDIT_PERMISSION_ACTION, VIEW_PERMISSION_ACTION];
const PERMISSION_PREFIX = 'permission.';
const ROLE_PREFIX = 'role.';
const DISABLE_ACTION = '.disabled';

export class PermissionActions {
    public view: string;
    public edit: string;
    public add: string;
    public delete: string;

    constructor(permission: string, availableActions: number) {

        let actions = (availableActions >>> 0).toString(2).padStart(4, '0');

        // See https://confluence.playtech.corp/display/MEXOSRND/Permission+Available+Actions
        let hasAddPermission: boolean = actions[0] === '1';
        let hasDeletePermission: boolean = actions[1] === '1';
        let hasEditPermission: boolean = actions[2] === '1';
        let hasViewPermission: boolean = actions[3] === '1';

        if (hasAddPermission) {
            this.add = permission + PERMISSION_ACTION_DELIMITER + ADD_PERMISSION_ACTION;
        }
        if (hasDeletePermission) {
            this.delete = permission + PERMISSION_ACTION_DELIMITER + DELETE_PERMISSION_ACTION;
        }
        if (hasEditPermission) {
            this.edit = permission + PERMISSION_ACTION_DELIMITER + EDIT_PERMISSION_ACTION;
        }
        if (hasViewPermission) {
            this.view = permission + PERMISSION_ACTION_DELIMITER + VIEW_PERMISSION_ACTION;
        }
    }
}

export interface MxPermissionService {
    hasPermission(perm: string): boolean;
    hasRole(role: string): boolean;
    getPermissionActions(permission: string): PermissionActions;
    getPermissionWithoutAction(permission: string): string;
    getEditPermission(permission: string): string;
}

export const MX_PERMISSION_TOKEN = new InjectionToken<MxPermissionService>('MX_PERMISSION_SERVICE');

export class MxPermissionServiceImpl implements MxPermissionService {

    public getPermissionActions(permission: string): PermissionActions {
        let permissionWithoutAction = this.getPermissionWithoutAction(permission);
        return new PermissionActions(permissionWithoutAction, 15);
    }

    getPermissionWithoutAction(permission: string): string {
        for (let action of ALL_PERMISSION_ACTIONS) {
            if (permission.endsWith(PERMISSION_ACTION_DELIMITER + action)) {
                return permission.substr(0, permission.length - action.length - 1);
            }
        }
        return permission;
    }

    public getEditPermission(permission: string): string {
        if (ALL_PERMISSION === permission) {
            return ALL_PERMISSION;
        }
        let perm = this.getPermissionWithoutAction(permission);
        if (perm.startsWith(ROLE_PREFIX)) {
            return perm;
        } else {
            return perm + '.edit';
        }
    }

    hasPermission(perm: string): boolean {
        return true;
    }

    hasRole(role: string): boolean {
        return true;
    }
}
